import engine from 'store/src/store-engine';
import store from 'store';

export const Storage = store;
export const Cookie = engine.createStore(
  [require('store/storages/cookieStorage')],
  [require('store/plugins/defaults')]
);
